import { render, staticRenderFns } from "./registration-order-list.vue?vue&type=template&id=448e84d8&scoped=true&"
import script from "./registration-order-list.vue?vue&type=script&lang=js&"
export * from "./registration-order-list.vue?vue&type=script&lang=js&"
import style0 from "./registration-order-list.vue?vue&type=style&index=0&id=448e84d8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448e84d8",
  null
  
)

export default component.exports